import { flow } from 'fp-ts/function';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getCustomerIdsByCompanyId } from '@mews-commander/legacy-entities/src/ducks';
import { commanderForm, withAutoFocusingFirstFocusableElement, validation } from '@mews-commander/legacy-form';
import { CommanderSidebar } from '../../../../components/sidebar';
import { getCustomerFormInitialValues } from '../../selectors';
import { CustomerFields } from '../Fields';

const constraints = {
    customerId: { presence: { allowEmpty: false, message: TextKey.InvalidCustomer } },
};

interface CustomerFormValues {
    customerId: string | null;
}

interface StateProps {
    initialValues: CustomerFormValues;
    customerIds: string[];
}

interface OwnProps {
    ownerId: string;
}

export default flow(
    commanderForm({
        validate: validation(constraints),
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Add} />,
        submitButtonProps: { variant: 'primary' },
    }),
    withAutoFocusingFirstFocusableElement(),
    connect<StateProps, null, OwnProps, ApplicationState>(
        createStructuredSelector({
            initialValues: getCustomerFormInitialValues,
            customerIds: (state: ApplicationState, { ownerId }: OwnProps) =>
                getCustomerIdsByCompanyId(state, { companyId: ownerId }),
        })
    ),
    CommanderSidebar
)(CustomerFields);
